
import React from 'react';
import { Facebook, Instagram, Youtube, Linkedin, MessageSquare, Globe, X } from 'lucide-react';

interface SocialMediaIconsProps {
  platform: string;
  className?: string;
}

// Create a TikTok icon component that can be exported for use elsewhere
export const BrandTiktok: React.FC<{className?: string}> = ({ className = "h-5 w-5" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <path d="M9 12a4 4 0 1 0 4 4V4c0-1.1.9-2 2-2h2" />
      <path d="M8 16a4 4 0 0 1 8 0v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4z" />
    </svg>
  );
};

export const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({ platform, className = "h-5 w-5" }) => {
  const platformLower = platform.toLowerCase();

  switch (platformLower) {
    case 'facebook':
      return <Facebook className={className} />;
    case 'twitter':
    case 'x':
      return <X className={className} />;
    case 'instagram':
      return <Instagram className={className} />;
    case 'youtube':
      return <Youtube className={className} />;
    case 'linkedin':
      return <Linkedin className={className} />;
    case 'snapchat':
      return <MessageSquare className={className} />; // Using a similar icon for Snapchat
    case 'tiktok':
      return <BrandTiktok className={className} />;
    case 'website':
    case 'hudl':
    default:
      return <Globe className={className} />; // Default icon for other platforms
  }
};
